/** @format */
// 状态 00：已锁车   01：已解锁
export enum DictLockStatus {
  Locked = '00',
  Unlock = '01'
}

export const dictLockStatusMap: {
  [key: string]: string;
} = {
  [DictLockStatus.Locked]: '已锁车',
  [DictLockStatus.Unlock]: '已解锁'
};

// 操作来源 00：平台   01：C端
export enum DictLockSource {
  Platform = '00',
  C = '01'
}

export const dictLockSourceMap: {
  [key: string]: string;
} = {
  [DictLockSource.Platform]: '平台',
  [DictLockSource.C]: 'H5微站点'
};

//下发状态 ：00 下发失败，01 下发成功，02 下发中，03 无需下发
export enum DictSendStatus {
  Fail = '00',
  Success = '01',
  InProgress = '02',
  NoNeed = '03'
}

export const dictSendStatusMap: {
  [key: string]: string;
} = {
  [DictSendStatus.Fail]: '下发失败',
  [DictSendStatus.Success]: '下发成功',
  [DictSendStatus.InProgress]: '下发中',
  [DictSendStatus.NoNeed]: '无需下发'
};
